import http from '../api/http'

export default {
  attributeOptionsByCode: (code) => http.get('/attributes/attribute-options-by-code', { params: { code } })
}



// WEBPACK FOOTER //
// ./src/services/attributes.js